import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconSeismic3DS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.5858 14L3 14C2.44772 14 2 13.5523 2 13L2 5.41421C2 5.149 2.10536 4.89464 2.29289 4.70711L4.70711 2.29289C4.89464 2.10536 5.149 2 5.41421 2L13 2C13.5523 2 14 2.44772 14 3L14 10.5858C14 10.851 13.8946 11.1054 13.7071 11.2929L11.2929 13.7071C11.1054 13.8946 10.851 14 10.5858 14Z"
        stroke="#97B2C4"
        fill="none"
      />
      <path
        d="M8.45833 5.5C5.25 5 3.72222 6.83333 2.5 7.5L2.5 10C3.72222 9.16667 6.71667 7.6 8.91667 8C11.1167 8.4 12.8889 7.5 13.5 7V2.5C12.5833 3.5 10.2732 5.78284 8.45833 5.5Z"
        fill="#FF4443"
      />
      <path
        d="M8.45833 9.76923C6.625 9.76923 4.5 9 2.5 10L2.5 13C3.72222 12.2308 6.84584 10.3197 8.91667 11.1538C11.2083 12.0769 12.8889 10.6923 13.5 10.2308V7C12.5833 7.92308 10.2917 9.76923 8.45833 9.76923Z"
        fill="#56B9F2"
      />
    </svg>
  )
}

export const IconSeismic3D = createIcon({
  l: IconSeismic3DS,
  m: IconSeismic3DS,
  s: IconSeismic3DS,
  xs: IconSeismic3DS,
  name: 'IconSeismic3D',
})
